// Type imports:
import { BookmarkTickData } from '../../types/api/BookmarkTypes';
import { ADD_BOOKMARK_FAILURE, ADD_BOOKMARK_SUCCESS, BookmarkActions, DELETE_BOOKMARK_FAILURE, DELETE_BOOKMARK_SUCCESS, EDIT_BOOKMARK_FAILURE, EDIT_BOOKMARK_SUCCESS, REQUEST_BOOKMARKS_FAILURE, REQUEST_BOOKMARKS_SUCCESS, REQUEST_BOOKMARKS_WAITING } from '../../types/redux/BookmarkTypes';

export interface IBookmarkState {
    bookmarks: null | Array<BookmarkTickData> | 'waiting',
    bookmarkError: string | null
}

const initialState: IBookmarkState = {
    bookmarks: null,
    bookmarkError: null
}

export default function(state: IBookmarkState = initialState, action: BookmarkActions) {
    switch(action.type) {
        /* REQUEST BOOKMARKS */
        case REQUEST_BOOKMARKS_WAITING: {
            const newState: IBookmarkState = {
                ...state,
                bookmarks: 'waiting'
            }
            return newState;
        }
        case REQUEST_BOOKMARKS_SUCCESS: {
            const { bookmarks } = action.payload;
            const bookmarkTickData: BookmarkTickData[] = bookmarks.map(bookmark => ({
                ...bookmark,
                tickdata_type: 'Bookmark'
            }))
            const newState: IBookmarkState = {
                ...state,
                bookmarks: bookmarkTickData,
                bookmarkError: null
            }
            return newState;
        }
        case REQUEST_BOOKMARKS_FAILURE: {
            const { error } = action.payload;
            const newState: IBookmarkState = {
                ...state,
                bookmarks: [],
                bookmarkError: error 
            }
            return newState;
        }
        /* ADD BOOKMARK */
        case ADD_BOOKMARK_SUCCESS: {
            const { bookmark } = action.payload;
            const bookmarkTick: BookmarkTickData = {
                ...bookmark,
                tickdata_type: 'Bookmark'
            }
            const bookmarksCopy = (Array.isArray(state.bookmarks))
                ? [...state.bookmarks]
                : [];
            bookmarksCopy.push(bookmarkTick);
            const newState: IBookmarkState = {
                ...state,
                bookmarks: bookmarksCopy
            };
            return newState;
        }
        case ADD_BOOKMARK_FAILURE: {
            const { error } = action.payload;
            const newState: IBookmarkState = {
                ...state,
                bookmarkError: error
            };
            return newState;
        }
        /* EDIT BOOKMARK */
        case EDIT_BOOKMARK_SUCCESS: {
            const { bookmark: editedBookmark } = action.payload;
            const editedBookmarkTick: BookmarkTickData = {
                ...editedBookmark,
                tickdata_type: 'Bookmark'
            }
            const bookmarksCopy = (Array.isArray(state.bookmarks)) ? [ ...state.bookmarks ] : [];
            const existingIndex = bookmarksCopy.findIndex(bookmark => bookmark.id === editedBookmarkTick.id);
            if (existingIndex !== -1) {
                bookmarksCopy[existingIndex] = editedBookmarkTick;
            }
            const newState: IBookmarkState = {
                ...state,
                bookmarks: bookmarksCopy
            };
            return newState;
        }
        case EDIT_BOOKMARK_FAILURE: {
            // TODO.
            const newState: IBookmarkState = {
                ...state
            };
            return newState;
        }
        /* DELETE BOOKMARK */
        case DELETE_BOOKMARK_SUCCESS: {
            const { bookmark: deletedBookmark } = action.payload;
            const bookmarksCopy = (Array.isArray(state.bookmarks))
                ? state.bookmarks.filter(bookmark => bookmark.id !== deletedBookmark.id)
                : state.bookmarks;
            const newState: IBookmarkState = {
                ...state,
                bookmarks: bookmarksCopy
            };
            return newState;
        }
        case DELETE_BOOKMARK_FAILURE: {
            // TODO.
            const newState: IBookmarkState = {
                ...state
            };
            return newState;
        }
        /* DEFAULT */
        default: {
            return state;
        }
    }
}